webpackJsonp([8],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	module.exports = __webpack_require__(15);


/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(3);
	
	function embedVideo(url, targetElement) {
	  if (_.includes(url, 'youtube')) {
	    id = url.split('?v=').slice(-1).pop();
	    element.innerHTML = '<iframe width="620" height="360" src="https://www.youtube.com/embed/'+id+'"></iframe>';
	  }
	  else if (_.includes(url, 'vimeo')) {
	    id = url.split('/').slice(-1).pop();
	    element.innerHTML =
	      '<iframe src="https://player.vimeo.com/video/' + id +
	      '" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
	  }
	}
	
	var element = document.getElementById('video');
	if (element)
	  embedVideo(element.dataset.source, element);


/***/ })

});


// WEBPACK FOOTER //
// gallery/gallery.5ef4be7ba0e7402967a1.js